import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { ObraEstruturaTreinamentos } from "../../models/obra_estrutura_treinamentos";
import { IGetAllObraEstruturaTreinamentosUseCase } from "../../../presentation/useCases/read/get_all_obra_estrutura_treinamento_use_case";
import { PlanoTreinamentoListaFilter } from "../../models/plano_treinamento_lista_filter";
import { PlanoTreinamentoLista } from "../../models/plano_treinamento_lista";


// GetAllObraEstruturaTreinamentUseCase


export class GetAllObraEstruturaTreinamentoUseCase
  extends BasePaginatedUseCase<PlanoTreinamentoLista>
  implements IGetAllObraEstruturaTreinamentosUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObraEstruturaTreinamento(
    filter: PlanoTreinamentoListaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllObraEstruturaTreinamento(
        filter,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }

  async createObraPlanoTreinamento(
    idObra: number | undefined,
    Cargo: string,
    TIPO_TREINAMENTO: string,
  ): Promise<void> {

    if (idObra === undefined) throw new Error('Id de obra invalido!');

     return await  this.repository
      .createObraPlanoTreinamento(
        idObra,
        Cargo,
        TIPO_TREINAMENTO,
      );
  }
}
